import { useSelector } from 'react-redux';
import { userDetailsSelector } from 'store/slices/userDetailsSlice';

export const useShouldDisplayArchivedSlides = (slide, order = undefined) => {
  const { isStaff, isPathologist } = useSelector(userDetailsSelector);

  const isArchived =
    slide?.is_storage_archived ||
    slide?.order?.is_storage_archived ||
    order?.is_storage_archived;

  const shouldDisplayArchivedSlides = !isArchived || isStaff || isPathologist;

  return shouldDisplayArchivedSlides;
};
